// extracted by mini-css-extract-plugin
module.exports =  {"select":"S78NjkCPZXcFunYW6vfH"};